import { type Action } from 'redux';

import { type User } from 'data/v1/data-contracts';
import { SET_USER } from 'constants/actions';

// the setUserFromJson action in actions/user transforms the permissions property into an array of numbers
type UserState = Omit<User, 'permissions'> & { permissions: number[] };

export interface SetUserAction extends Action<typeof SET_USER> {
  user: UserState;
}

const initialState = {} as UserState;

// eslint-disable-next-line default-param-last
export default function user(state = initialState, action: SetUserAction) {
  switch (action.type) {
    case SET_USER:
      return { ...action.user };
    default:
      return state;
  }
}
